// extracted by mini-css-extract-plugin
export default {"column":"order-sidebar_column__R9km7"};